export default __webpack_public_path__ + "static/media/BG-MARTINEZ_Desktop.a2c4a281.jpg";